import { render, staticRenderFns } from "./TaxabilityTable.vue?vue&type=template&id=ffb6bdf0&scoped=true"
import script from "./TaxabilityTable.vue?vue&type=script&lang=ts"
export * from "./TaxabilityTable.vue?vue&type=script&lang=ts"
import style0 from "./TaxabilityTable.vue?vue&type=style&index=0&id=ffb6bdf0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb6bdf0",
  null
  
)

export default component.exports